import Vue from 'vue';
import { defineStore } from 'pinia';
import _ from 'lodash';

import GenerativeMediaApi from '@/extensions/generative-media/store/api/generativeMedia';

export const usePromptTemplateStore = defineStore('promptTemplate', {
    state: () => ({
        loading: true,
        cmsId: null,
        promptTemplatesPaginated: {
            variables: {
                order: 'created_at',
                direction: 'desc',
                paginationSizes: [25, 50, 100]
            },
            filters: {},
            pageInfo: {
                total: 0,
                perPage: 25,
                currentPage: 1,
                lastPage: 0
            },
            allColumns: [],
            activeColumns: [],
            showFilters: false,
            defaultSort: null,
            link: {},
            items: []
        }
    }),

    actions: {
        setCmsId(id) {
            this.cmsId = id;
        },

        addPaginatedEntriesToState(data) {
            this.promptTemplatesPaginated.items = data.items;
            this.promptTemplatesPaginated.pageInfo = _.cloneDeep(data.pageInfo);
            this.promptTemplatesPaginated.allColumns = _.cloneDeep(data.config.allColumns);
            this.promptTemplatesPaginated.link = _.cloneDeep(data.config.link);
            this.promptTemplatesPaginated.showFilters = _.get(data.config, 'showFilters') || false;
            this.promptTemplatesPaginated.defaultSort = _.get(data.config, 'defaultSort') || null;
        },

        defineActiveColumns(activeColumnKeys) {
            const activeColumns = [];
            _.each(this.promptTemplatesPaginated.allColumns, column => {
                const allowed = _.find(activeColumnKeys, value => column.key === value);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.promptTemplatesPaginated.activeColumns = activeColumns;
            }
        },

        defineItemsPerPage(perPage) {
            this.promptTemplatesPaginated.pageInfo.perPage = perPage;
        },

        defineCurrentPage(currentPage) {
            this.promptTemplatesPaginated.pageInfo.currentPage = currentPage;
        },

        defineFilterValue({ key, value }) {
            if (value.match === '' && value.like === '' && value.from === '' && value.to === '' && value.in.length === 0) {
                Vue.delete(this.promptTemplatesPaginated.filters, key);
            } else {
                Vue.set(this.promptTemplatesPaginated.filters, key, value);
            }
        },

        defineSorting({ key, value }) {
            this.promptTemplatesPaginated.variables.order = key;
            this.promptTemplatesPaginated.variables.direction = value;
        },

        defineFilterVisibility(value) {
            this.promptTemplatesPaginated.showFilters = value;
        },

        updateLoading(value) {
            this.loading = value;
        },

        fetchPromptTemplatesPaginated() {
            return GenerativeMediaApi.fetchPromptTemplatesPaginated(this.promptTemplatesPaginated, this.cmsId).then(data => {
                this.addPaginatedEntriesToState(data);

                const activeColumnKeys = _.map(data.config.activeColumnKeys, 'key');
                this.defineActiveColumns(activeColumnKeys);
            });
        },

        savePromptTemplate(template) {
            return GenerativeMediaApi.savePromptTemplate(this.cmsId, template);
        },

        deletePromptTemplate(id) {
            return GenerativeMediaApi.deletePromptTemplate(id);
        }
    }
});
